import { FC } from "react";
import { QESWidget, QESWidgetContent, QESWidgetHeader, QESWidgetTitle } from "@app/shared/widget";

const NetworkCompositionWidget: FC = () => (
    <div data-testid="compliance-connect__network-composition-widget">
        <QESWidget className="w-100">
            <QESWidgetHeader>
                <QESWidgetTitle>Network Composition by Gap and Exception</QESWidgetTitle>
            </QESWidgetHeader>
            <QESWidgetContent>
            </QESWidgetContent>
        </QESWidget>
    </div>
);

export default NetworkCompositionWidget;
